import { render } from "./product-gallery.vue?vue&type=template&id=5417aae2"
import script from "./product-gallery.vue?vue&type=script&lang=js"
export * from "./product-gallery.vue?vue&type=script&lang=js"

import "./product-gallery.vue?vue&type=style&index=0&id=5417aae2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__